import { JsonRpcProvider, Web3Provider } from "@ethersproject/providers"
import { InjectedConnector } from "@web3-react/injected-connector"
import { NetworkConnector } from "@web3-react/network-connector"
import { WalletConnectConnector } from "@web3-react/walletconnect-connector"
import { WalletLinkConnector } from "@web3-react/walletlink-connector"

export enum CHAIN_ID {
    Ethereum = 1,
}

const RPC_URLS = {
    [CHAIN_ID.Ethereum]: "https://few-frosty-river.quiknode.pro/403c0145bb2c6770cabf93245f036c9e2d51e5a1/",
}

export const network = new NetworkConnector({
    urls: RPC_URLS,
    defaultChainId: CHAIN_ID.Ethereum,
})

export function getNetworkLibrary(): Web3Provider {
    const url = RPC_URLS[CHAIN_ID.Ethereum]

    return new JsonRpcProvider(url) as Web3Provider
}

// see all chain ids in https://chainid.network/
export const injected = new InjectedConnector({
    supportedChainIds: [CHAIN_ID.Ethereum],
})

export const walletConnect = new WalletConnectConnector({
    rpc: {
        [CHAIN_ID.Ethereum]: RPC_URLS[CHAIN_ID.Ethereum],
    },
    pollingInterval: 15000,
})

/**
 * https://www.walletlink.org/#/
 * https://github.com/NoahZinsmeister/web3-react
 */
export const walletLink = new WalletLinkConnector({
    url: RPC_URLS[CHAIN_ID.Ethereum],
    appName: "Staking | Perpetual Protocol",
})
